import { useLocalStorage } from './useLocalStorage'

export const useKYCDismissed = () =>
  useLocalStorage<boolean | null>('kycDismissed', null)
